import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "buttons"]
  static values = {
    autoSubmit: Boolean,
    resetDates: Boolean
  }

  connect() {
    this.options = JSON.parse(this.inputTarget.dataset.options)
    this.renderButtons()
    this.updateButtons()
  }

  renderButtons() {
    this.buttonsTarget.innerHTML = ""
    this.options.forEach((option, idx) => {
      const button = document.createElement("button")
      button.type = "button"
      button.textContent = option.label
      button.dataset.value = option.value

      // Adiciona borda esquerda só nos botões que não são o primeiro
      let classes = "px-4 py-2 bg-white text-gray-700 "
      classes += " border-t border-b" // sempre borda superior e inferior
      if (idx === 0) {
        classes += " border-l border-gray-300 rounded-l-md" // primeiro: borda esquerda
      } else {
        classes += " border-l border-gray-300" // outros: só borda esquerda
      }
      // Opcional: último botão pode ter borda direita
      if (idx === this.options.length - 1) {
        classes += " border-r border-gray-300 rounded-r-md"
      }

      button.className = classes
      button.addEventListener("click", () => this.select(option.value))
      this.buttonsTarget.appendChild(button)
    })

  }

  select(value) {
    const changed = this.inputTarget.value !== value
    this.inputTarget.value = value
    this.updateButtons()

    if (changed && this.autoSubmitValue) {
      this.submitWithDefaults(value)
    }
  }

  submitWithDefaults(periodicyValue) {
    const form = this.element.closest("form")
    if (!form) return

    if (this.resetDatesValue) {
      this.resetDateRange(form, periodicyValue)
    }

    const pageInput = form.querySelector('input[name="page"]')
    if (pageInput) {
      pageInput.value = ""
    }

    form.requestSubmit()
  }

  resetDateRange(form, periodicyValue) {
    const startDateInput = form.querySelector('input[name="start_date"]')
    const endDateInput = form.querySelector('input[name="end_date"]')

    if (!startDateInput || !endDateInput) return

    const endDate = new Date()
    endDate.setHours(0, 0, 0, 0)

    const startDate = new Date(endDate)
    const daysToSubtract = periodicyValue === "10min" ? 7 : 30
    startDate.setDate(startDate.getDate() - daysToSubtract)

    startDateInput.value = this.formatDate(startDate)
    endDateInput.value = this.formatDate(endDate)
  }

  formatDate(date) {
    const year = date.getFullYear()
    const month = `${date.getMonth() + 1}`.padStart(2, "0")
    const day = `${date.getDate()}`.padStart(2, "0")
    return `${year}-${month}-${day}`
  }

  updateButtons() {
    const selectedValue = this.inputTarget.value
    Array.from(this.buttonsTarget.children).forEach(button => {
      if (button.dataset.value === selectedValue) {
        button.classList.add("bg-enercon-green-1", "text-white")
        button.classList.remove("bg-white", "text-gray-700","hover:bg-gray-100")
      } else {
        button.classList.remove("bg-enercon-green-1", "text-white")
        button.classList.add("bg-white", "text-gray-700","hover:bg-gray-100")
      }
    })
  }
}

